/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/* ==========================================================================
   STERED - Carrousels de collections : démarrage sur le 2e produit sur mobile uniquement
   ========================================================================== */
function startOnSecondProduct() {
  if (window.innerWidth > 749) {
    return;
  }

  var carousels = document.querySelectorAll(
    '[data-section-id*="__section_collection_"] items-scroll-paged-navigation'
  );

  carousels.forEach(function (carousel) {
    var track = carousel.querySelector('[data-items]');
    var cards = track ? track.querySelectorAll('.product-card') : null;

    if (!track || !cards || !cards[1]) {
      return;
    }

    var secondProductPosition = cards[1].offsetLeft;

    if (typeof track.scrollTo === 'function') {
      track.scrollTo({
        left: secondProductPosition,
        behavior: 'auto'
      });
    } else {
      track.scrollLeft = secondProductPosition;
    }
  });
}

function runSecondProduct() {
  setTimeout(startOnSecondProduct, 100);
  setTimeout(startOnSecondProduct, 700);
  setTimeout(startOnSecondProduct, 1500);
}

document.addEventListener('DOMContentLoaded', runSecondProduct);
window.addEventListener('load', runSecondProduct);
document.addEventListener('shopify:section:load', runSecondProduct);

document.addEventListener('click', function (event) {
  var clickedElement =
    event.target instanceof Element ? event.target : null;

  if (
    clickedElement &&
    clickedElement.closest(
      '[data-section-id*="__section_collection_"] [role="tab"],' +
      '[data-section-id*="__section_collection_"] [aria-controls^="tab-collection_"],' +
      '[data-section-id*="__section_collection_"] .tab-triggers *'
    )
  ) {
    runSecondProduct();
  }
});

/* Lancement immédiat, y compris si le script est chargé après DOMContentLoaded */
runSecondProduct();


/*
 * Changement d’image au clic sur un coloris
 * Page collection
 */

document.addEventListener(
  'click',
  function (event) {
    const swatch = event.target.closest(
      '.product-card__swatch__link[data-swatch-image], .product-card__sibling-swatch-link[data-swatch-image]'
    );

    if (!swatch) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const productCard = swatch.closest('product-card, .product-card');

    if (!productCard) {
      return;
    }

    const productImage = productCard.querySelector(
      'img.js-product-card-image, img.product-card__image'
    );

    const hoverImage = productCard.querySelector(
      'img.product-card__img-hover, img.product-card__img--hover, .product-card__img--hover img'
    );

    if (!productImage) {
      return;
    }

    const imageUrl = swatch.dataset.swatchImage;
    const hoverImageUrl =
      swatch.dataset.swatchHoverImage || imageUrl;
    const imageAlt = swatch.dataset.swatchImageAlt || '';
    const productUrl = swatch.dataset.swatchUrl;
    const productTitle = swatch.dataset.swatchTitle || '';


    /* Image principale */
    if (imageUrl) {
      productImage.setAttribute('src', imageUrl);
      productImage.src = imageUrl;
      productImage.removeAttribute('srcset');
      productImage.removeAttribute('sizes');
      productImage.alt = imageAlt;
    }

    /* Image au survol */
    if (hoverImage && hoverImageUrl) {
      hoverImage.setAttribute('src', hoverImageUrl);
      hoverImage.src = hoverImageUrl;
      hoverImage.removeAttribute('srcset');
      hoverImage.removeAttribute('sizes');
      hoverImage.alt = imageAlt;
    }

    /* Titre du coloris sélectionné */
if (productTitle) {
  productCard
    .querySelectorAll('product-card-title')
    .forEach(function (titleElement) {
      titleElement.textContent = productTitle;
    });
}

    /* Lien de l’image et du titre vers le coloris sélectionné */
    if (productUrl) {
      productCard
        .querySelectorAll(
          'a[href*="/products/"]:not(.product-card__swatch__link):not(.product-card__sibling-swatch-link)'
        )
        .forEach(function (link) {
          link.href = productUrl;
        });
    }

    /* Mise à jour du rond sélectionné */
    productCard
      .querySelectorAll(
        '.product-card__swatch__link[aria-current], .product-card__sibling-swatch-link[aria-current]'
      )
      .forEach(function (link) {
        link.removeAttribute('aria-current');
      });

    swatch.setAttribute('aria-current', 'page');
  },
  true
);

/* ==========================================================================
   STERED - Masquer "Afficher plus" lorsqu'il n'y a plus de produit visible

   Shopify vérifie la pagination avant que les produits FAUX soient masqués.
   Ce contrôle ouvre discrètement la page suivante et cache le bouton si
   cette page ne contient aucune carte produit visible.
   ========================================================================== */

(function () {
  function checkNextCollectionPage() {
    var nextLinks = document.querySelectorAll(
      '.js-infinite-pagination a[rel="next"]'
    );

    nextLinks.forEach(function (nextLink) {
      if (!nextLink.href) {
        return;
      }

      if (nextLink.dataset.visibleProductsChecked === 'true') {
        return;
      }

      nextLink.dataset.visibleProductsChecked = 'true';

      var section =
        nextLink.closest('[data-section-id]') || document;

      var loadMoreButton = section.querySelector(
        '.js-infinite-load-button'
      );

      if (!loadMoreButton) {
        return;
      }

      fetch(nextLink.href, {
        credentials: 'same-origin'
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Impossible de vérifier la page suivante');
          }

          return response.text();
        })
        .then(function (html) {
          var nextDocument = new DOMParser().parseFromString(
            html,
            'text/html'
          );

          var visibleProductCards =
            nextDocument.querySelectorAll('.product-card');

          if (visibleProductCards.length === 0) {
            loadMoreButton.hidden = true;
            loadMoreButton.setAttribute('aria-hidden', 'true');

            var paginationLink =
              nextLink.closest('.js-infinite-pagination');

            if (paginationLink) {
              paginationLink.hidden = true;
            }
          }
        })
        .catch(function () {
          /*
           En cas d'erreur réseau, on laisse le bouton visible.
           Cela évite de bloquer la pagination par erreur.
           */
        });
    });
  }

  function scheduleNextPageCheck() {
    setTimeout(checkNextCollectionPage, 500);
    setTimeout(checkNextCollectionPage, 1500);
  }

  document.addEventListener(
    'DOMContentLoaded',
    scheduleNextPageCheck
  );

  window.addEventListener(
    'load',
    scheduleNextPageCheck
  );

  document.addEventListener(
    'shopify:section:load',
    scheduleNextPageCheck
  );

  document.addEventListener(
    'click',
    function (event) {
      var clickedElement =
        event.target instanceof Element
          ? event.target
          : null;

      if (
        clickedElement &&
        clickedElement.closest('.js-infinite-load-button')
      ) {
        setTimeout(checkNextCollectionPage, 1500);
      }
    }
  );
})();


/* Qualité & fabrication : démarrer sur la 2e image sur mobile */
function startQualityCarousel() {
  if (window.innerWidth > 767) return;

  const carousel = document.querySelector(
    '[data-section-id="template--31420785426780__section_multi_column_images_ffNaNM"] items-scroll-paged-navigation'
  );
  if (!carousel || carousel.dataset.secondImage) return;

  const track = carousel.querySelector('[data-items]');
  if (!track?.children[1] || !carousel.hasAttribute('scroll-enabled')) return;

  track.scrollTo({
    left: track.children[1].offsetLeft,
    behavior: 'instant'
  });
  carousel.dataset.secondImage = 'done';
}

function initQualityCarousel() {
  [100, 700, 1500].forEach(delay =>
    setTimeout(startQualityCarousel, delay)
  );
}

initQualityCarousel();
window.addEventListener('load', initQualityCarousel);
document.addEventListener('shopify:section:load', initQualityCarousel);


